
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-start justify-between mb-12">
          <div className="flex items-center space-x-3">
            <img
              src="https://public.readdy.ai/ai/img_res/29cb4625-055a-4b6c-9f0b-d6804c39a8b0.png"
              alt="SPA Logo"
              className="h-10 w-10 object-contain"
            />
            <span className="text-xl font-serif font-semibold">GOLDEN MOUNTAIN spa</span>
          </div>
          <div className="text-sm text-gray-400">Making every experience nourish your body and mind</div>
        </div>

        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="text-base font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <button onClick={() => scrollToSection('hero')} className="hover:text-white transition-colors cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-white transition-colors cursor-pointer">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="hover:text-white transition-colors cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-white transition-colors cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Service Categories</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">Aromatherapy</li>
              <li className="hover:text-white transition-colors cursor-pointer">Massage Therapy</li>
              <li className="hover:text-white transition-colors cursor-pointer">Facial Care</li>
              <li className="hover:text-white transition-colors cursor-pointer">Body Care</li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold mb-4">Customer Service</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li className="hover:text-white transition-colors cursor-pointer">FAQ</li>
              <li className="hover:text-white transition-colors cursor-pointer">Membership</li>
              <li className="hover:text-white transition-colors cursor-pointer">Promotions</li>
              <li className="hover:text-white transition-colors cursor-pointer">Contact Us</li>
            </ul>
          </div>

          <div>
            <div className="text-lg font-serif mb-2">© 2024 GOLDEN MOUNTAIN spa</div>
            <div className="text-sm text-gray-400 mb-4">All rights reserved</div>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm underline cursor-pointer">
                WeChat
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm underline cursor-pointer">
                Weibo
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm underline cursor-pointer">
                Xiaohongshu
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm underline cursor-pointer">
                Douyin
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-12">
          <div className="grid md:grid-cols-3 gap-8 items-center">
            <div>
              <div
                className="w-full h-32 rounded-2xl bg-cover bg-center"
                style={{
                  backgroundImage: 'url(https://public.readdy.ai/ai/img_res/09609a36e5c85782ca14a035e60876cf.jpg)',
                }}
              ></div>
            </div>

            <div className="text-center">
              <div className="text-3xl font-serif font-light leading-tight">
                Dedicated<br />
                To Healing<br />
                For 10 Years
              </div>
            </div>

            <div>
              <div className="text-sm text-gray-400 mb-4 leading-relaxed">
                Subscribe to our wellness newsletter<br />
                Get the latest promotions
              </div>
              <div className="flex">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 bg-transparent border border-gray-700 rounded-l-full text-sm text-white placeholder-gray-500 focus:outline-none focus:border-gray-500"
                />
                <button className="px-6 py-3 bg-blue-600 text-white rounded-r-full hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
                  Subscribe →
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 text-center text-xs text-gray-500">
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-gray-400 transition-colors">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
